import { ModelDef } from '../../CORE/src/common/$models/ModelDef'

/**
 * 見積:家財種別子カテゴリマスタ
 */
export const yhc_kazai_types_sub_categories: ModelDef = {
  tableName: 'yhc_kazai_types_sub_categories',
  tableLabel: '見積:家財種別子カテゴリマスタ',
  primaryKeyColType: 'NUMBER',
  defaultSort: { key: 'sort', order: 'asc' },
  columns: {
    category: {
      type: 'STRING',
      label: '家財カテゴリ',
      selectionsWithSelectOptionsMasterGroupName: '家財カテゴリ',
    },
    name: {
      type: 'STRING',
      label: '名称',
      inputHelpText: '例: "冷蔵庫", "洗濯機"',
      validate: { notEmpty: true },
    },
    sort: {
      type: 'NUMBER',
      label: '表示順 (昇順)',
      validate: { notEmpty: true },
    },
    thumbnail: {
      type: 'FILE',
      label: 'アイコン画像',
    },
    receivingConditions: {
      type: 'RICHTEXT',
      label: '荷受け条件',
      visible: false,
      editable: false,
      replicable: true,
      width: { xs: 48 },
    },
  },
}
